

// import React, { useState } from "react";
// import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterNormalUser.module.scss";
// import Pagination from "../../Components/Common/Pagination";
// import { FaEye } from "react-icons/fa";

// const SubscriptionAdmin = () => {

//   // 🔥 STATIC DATA
//   const tableData = [
//     { id: 1, name: "Arun Kumar", mobile: "9876543210", type: "Premium", panId: "ABCDE1234F", expPlan: "Gold Plan", joiningDate: "12/01/2024" },
//     { id: 2, name: "Sathish", mobile: "9123456780", type: "Basic", panId: "PQRSX5678L", expPlan: "Silver Plan", joiningDate: "25/03/2024" },
//     { id: 3, name: "Vignesh", mobile: "9988776655", type: "Enterprise", panId: "LMNOP4321Z", expPlan: "Platinum Plan", joiningDate: "05/06/2024" },
//     { id: 4, name: "Ramesh", mobile: "9090909090", type: "Premium", panId: "ASDFG6789K", expPlan: "Gold Plan", joiningDate: "10/07/2024" },
//     { id: 5, name: "Karthik", mobile: "9887766554", type: "Basic", panId: "ZXCVB1234P", expPlan: "Silver Plan", joiningDate: "20/08/2024" },
//     { id: 6, name: "Praveen", mobile: "9001122334", type: "Enterprise", panId: "QWERT5678M", expPlan: "Platinum Plan", joiningDate: "15/09/2024" },
//   ];

//   // 🔥 PAGINATION STATE
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   const totalCount = tableData.length;
//   const totalPages = Math.ceil(totalCount / limit);

//   const indexOfLast = currentPage * limit;
//   const indexOfFirst = indexOfLast - limit;
//   const currentData = tableData.slice(indexOfFirst, indexOfLast);

//   return (
//     <div className={Styles.parent}>
//       <div className={Styles.box}>

//         <h1 className={Styles.heading}>Subscription Admin</h1>

//         {/* ================= TABLE ================= */}
//         <div className={Styles.tableWrapper}>
//           <table className={Styles.table}>
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Mob Num</th>
//                 <th>Type</th>
//                 <th>Current Plan Name</th>
//                 <th>Exp Plan</th>
//                 <th>Joining Date</th>
//                 {/* <th>Action</th> */}
//               </tr>
//             </thead>

//             <tbody>
//               {currentData.map((item) => (
//                 <tr key={item.id}>
//                   <td>{item.name}</td>
//                   <td>{item.mobile}</td>
//                   <td>{item.type}</td>
//                   <td>{item.panId}</td>
//                   <td>{item.expPlan}</td>
//                   <td>{item.joiningDate}</td>
//                   {/* <td>
//                     <FaEye className={Styles.viewIcon} />
//                   </td> */}
//                 </tr>
//               ))}
//             </tbody>

//           </table>
//         </div>

//         {/* ================= PAGINATION ================= */}
//         <div className={Styles.paginationContainer}>
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={setCurrentPage}
//           />

//           <select
//             value={limit}
//             className={Styles.inputsbtn}
//             onChange={(e) => {
//               setLimit(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10 rows</option>
//             <option value={25}>25 rows</option>
//             <option value={50}>50 rows</option>
//           </select>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default SubscriptionAdmin;

// import React, { useState } from "react";
// import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterNormalUser.module.scss";
// import Pagination from "../../Components/Common/Pagination";
// import { useGetAdminPaymentHistoryQuery } from "../../slices/admin/admin";
// import { getUserInfo } from "../../utils/user.util";

// const SubscriptionAdmin = () => {

//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   // ✅ Get Logged-in User
//   const localUser = getUserInfo();
//   const userId = localUser?._id;

//   // 🔥 API CALL
//   const { data, isLoading, isError } =
//     useGetAdminPaymentHistoryQuery(
//       { offset: currentPage, limit, userId },
//       { skip: !userId } // ✅ prevent API call if no userId
//     );

//   const tableData = data?.data || [];
//   const totalCount = data?.total || 0;
//   const totalPages = Math.ceil(totalCount / limit);

//   return (
//     <div className={Styles.parent}>
//       <div className={Styles.box}>
//         <h1 className={Styles.heading}>Subscription Admin</h1>

//         <div className={Styles.tableWrapper}>
//           <table className={Styles.table}>
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Mob Num</th>
//                 <th>Type</th>
//                 <th>Current Plan</th>
//                 <th>Exp Plan</th>
//                 <th>Joining Date</th>
//               </tr>
//             </thead>

//             <tbody>
//               {isLoading ? (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center" }}>
//                     Loading...
//                   </td>
//                 </tr>
//               ) : isError ? (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center", color: "red" }}>
//                     Failed to load data
//                   </td>
//                 </tr>
//               ) : tableData.length === 0 ? (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center" }}>
//                     No Data Found
//                   </td>
//                 </tr>
//               ) : (
//                 tableData.map((item) => (
//                   <tr key={item._id}>
//                     <td>{item.firstName} {item.lastName}</td>
//                     <td>{item.phone}</td>
//                     <td>{item.type}</td>
//                     <td>{item.isPaid ? "Paid" : "Free"}</td>
//                     <td>{item.planExpiredAt || "N/A"}</td>
//                     <td>
//                       {new Date(item.createdAt).toLocaleDateString()}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div className={Styles.paginationContainer}>
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={setCurrentPage}
//           />

//           <select
//             value={limit}
//             className={Styles.inputsbtn}
//             onChange={(e) => {
//               setLimit(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10 rows</option>
//             <option value={25}>25 rows</option>
//             <option value={50}>50 rows</option>
//           </select>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default SubscriptionAdmin;


// import React, { useState } from "react";
// import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterNormalUser.module.scss";
// import Pagination from "../../Components/Common/Pagination";
// import { useGetAdminPaymentHistoryQuery } from "../../slices/admin/admin";

// const SubscriptionAdmin = () => {

//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   // 🔥 API CALL (NO userId)
//   const { data, isLoading, isError } =
//     useGetAdminPaymentHistoryQuery({
//       offset: currentPage,
//       limit,
//     });

//   const tableData = data?.data || [];
//   const totalCount = data?.total || 0;
//   const totalPages = Math.ceil(totalCount / limit);

//   return (
//     <div className={Styles.parent}>
//       <div className={Styles.box}>
//         <h1 className={Styles.heading}>Subscription Admin</h1>

//         <div className={Styles.tableWrapper}>
//           <table className={Styles.table}>
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Mob Num</th>
//                 <th>Type</th>
//                 <th>Current Plan</th>
//                 <th>Exp Plan</th>
//                 <th>Joining Date</th>
//               </tr>
//             </thead>

//             <tbody>
//               {isLoading ? (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center" }}>
//                     Loading...
//                   </td>
//                 </tr>
//               ) : isError ? (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center", color: "red" }}>
//                     Failed to load data
//                   </td>
//                 </tr>
//               ) : tableData.length === 0 ? (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center" }}>
//                     No Data Found
//                   </td>
//                 </tr>
//               ) : (
//                 tableData.map((item) => (
//                   <tr key={item._id}>
//                     <td>{item.firstName} {item.lastName}</td>
//                     <td>{item.phone}</td>
//                     <td>{item.type}</td>
//                     <td>{item.isPaid ? "Paid" : "Free"}</td>
//                     <td>{item.planExpiredAt || "-"}</td>
//                     <td>
//                       {new Date(item.createdAt).toLocaleDateString()}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div className={Styles.paginationContainer}>
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={setCurrentPage}
//           />

//           <select
//             value={limit}
//             className={Styles.inputsbtn}
//             onChange={(e) => {
//               setLimit(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10 rows</option>
//             <option value={25}>25 rows</option>
//             <option value={50}>50 rows</option>
//           </select>
//         </div>

//       </div>
//     </div>
//   );
// };
import React, { useState } from "react";
import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterNormalUser.module.scss";
import inventoryStyles from "../../assets/scss/InventoryManagement/InventoryTable.module.scss";
import settingStyles from "../../assets/scss/Settings/Settings.module.scss";
import Pagination from "../../Components/Common/Pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useGetAdminPaymentHistoryQuery, useSendPaymentReminderMutation } from "../../slices/admin/admin";
import { toast } from "react-toastify";

const SubscriptionAdmin = () => {

  const [sendPaymentReminder] = useSendPaymentReminderMutation();
  const [notifyingUserId, setNotifyingUserId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // ✅ date format for API
  const formatDate = (date) => {
    if (!date) return undefined;
    return date.toISOString().split("T")[0];
  };

  // ✅ date + time format for table
  const formatDateTime = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const { data, isLoading, isError } =
    useGetAdminPaymentHistoryQuery({
      offset: currentPage,
      limit,
      search: search || undefined,
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
    });

  const tableData = data?.data || [];
  const totalCount = data?.total || 0;
  const totalPages = Math.ceil(totalCount / limit);


  console.log(tableData,"tableData333hreherherh");
  

  const isExpiringSoon = (expiryDate) => {
    if (!expiryDate) return false;

    const today = new Date();
    const expiry = new Date(expiryDate);

    today.setHours(0, 0, 0, 0);
    expiry.setHours(0, 0, 0, 0);

    const diffDays = Math.ceil(
      (expiry - today) / (1000 * 60 * 60 * 24)
    );

    return diffDays <= 5 && diffDays >= 0;
  };
  // ✅ Clear Filters
  const handleClearFilters = () => {
    setSearch("");
    setFromDate(null);
    setToDate(null);
    setCurrentPage(1);
  };
  const handleNotify = async (userId) => {
    setNotifyingUserId(userId);
    try {
      const response = await sendPaymentReminder(userId).unwrap();
      toast.success(response?.message || "Notification and email sent successfully");
    } catch (error) {
      toast.error(error?.data?.message || "Failed to send notification");
    } finally {
      setNotifyingUserId(null);
    }
  };

  return (
    <div className={inventoryStyles.inventoryContainer}>
      <div className={settingStyles.headerRow}>
        <h2 className={settingStyles.header}>Subscription Maintenance</h2>
      </div>
      <div className={Styles.box}>
        {/* 🔎 FILTERS */}
        <div className={Styles.filterContainer}>

          <input
            className={Styles.searchInput}
            type="text"
            placeholder="Search by Name / Phone..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />

          <DatePicker
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);
              setCurrentPage(1);
            }}
            dateFormat="dd.MM.yyyy"
            placeholderText="From Date"
            isClearable
            className={Styles.inputss}
          />

          <DatePicker
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              setCurrentPage(1);
            }}
            dateFormat="dd.MM.yyyy"
            placeholderText="To Date"
            isClearable
            className={Styles.inputss}
          />

          {/* ✅ CLEAR FILTER BUTTON */}
          <button
            onClick={handleClearFilters}
            className={Styles.clearBtn}
          >
            Clear Filters
          </button>

        </div>

        {/* TABLE */}
        <div className={Styles.tableWrapper}>
          <table className={Styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Mob Num</th>
                <th>Type</th>
                <th>Plan Name</th>
                <th>Price</th>
                <th>Method</th>
                <th>Exp Plan</th>
                <th>Joining Date</th>
                <th>Notify</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : isError ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center", color: "red" }}>
                    Failed to load data
                  </td>
                </tr>
              ) : tableData.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              ) : (
                tableData.map((item) => (
                  <tr key={item._id}>
                    <td>{item.firstName} {item.lastName}</td>
                    <td>{item.phone}</td>
                    <td>{item.type}</td>
                    <td>{item.currentPlan?.planName || (item.isPaid ? "Paid" : "Free")}</td>
                    <td>{item.lastPayment?.amount || 0}</td>
                    <td>{item.lastPayment?.paymentInfo?.method || "-"}</td>
                    <td>{formatDateTime(item.planExpiredAt)}</td>
                    <td>{formatDateTime(item.createdAt)}</td>
                    <td>
                      <button
                        className={Styles.addButton}
                        onClick={() => handleNotify(item._id)}
                        disabled={notifyingUserId === item._id}
                      >
                        {notifyingUserId === item._id ? "Sending..." : "Notify"}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className={Styles.paginationContainer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            value={limit}
            className={Styles.inputsbtn}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>

      </div>
    </div>
  );
};

export default SubscriptionAdmin;
